const state = {
    seachKey: ""
}

const mutations = {
    SET_SEACH_KEY: (state, key) => {
        state.seachKey = key
    }
}



export default {
    namespaced: true,
    state,
    mutations
}
